<template>
  <div class="user-wrp-comments">
    <div class="result-bracket__title user__list-count">
      <span class="result-bracket__count">{{ comments.length }} </span> Yorum Bulunuyor!
    </div>
    <div class="user__list-offer">
      <div class="user__list-offer__item" v-for="msg in comments" :key="msg.id">
        <div class="user__list-comment-wrp">
          <div class="user__list__dorm">
            <div class="user__list__dorm-img-wrp">
                 <span class="logo-wrp__icon">
                      <svg-icon type="icon-user"/>
                    </span>
            </div>
            <div class="user__list__dorm-wrp">
              <p class="user__list__dorm-name">{{ msg.user.first_name }} {{ msg.user.last_name }}</p>

              <div class="user__list__dorm-gen">
                <span class="user__list__dorm-location">
                 <svg-icon class="user__list__dorm-location-svg" type="icon-envelope-box"/>
                {{ msg.user.email }}</span>

                <span class="user__list__dorm-location">
                 <svg-icon class="user__list__dorm-location-svg" type="icon-phone-classic"/>
                {{ msg.user.phone }}</span>
              </div>

            </div>
          </div>

          <div class="right-bar" style="margin-top: 15px;">
            <p class="user__list-date"> {{ msg.date }}</p>
            <p class="user__list-date">
              <span class="user__list__dorm-hour">
                 <svg-icon class="user__list__dorm-hour-svg" type="icon-oclock"/>
              </span>
              {{ msg.created_at }}
            </p>
          </div>
        </div>

        <div class="user__list-comment">
          <div class="user__list-link">
            <div class="user__list-bottom">
              <p class="user__list-bottom-title" style="margin-left: 0">
                               <span class="location-ico">
               <svg-icon type="icon-location"/>
            </span>{{ msg.dorm.name }}, {{ msg.dorm.city_name }}, {{ msg.dorm.address }}
              </p>
            </div>
            <div class="user__list-bottom">
              <p class="user__list-bottom-title" style="margin-left: 0">
               {{ msg.comment }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--     <div class="pagination">
      <a href="#" class="pagination__item page-active"><span class="pagination__item-number">1</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">2</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">3</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">4</span></a>

    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'DormComment',
  data () {
    return {
      dorms:[],
      errors: [],
      logo: '',
      comments: [],
      cities: []
    }
  },
  methods: {
    getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
          self.getComments ()
        })
        .catch(e => {
          this.errors.push(e)
        })
    },     
        getComments () {
          var self = this        
      axios.get(`/dorm/comments`)
        .then(response => {
          self.comments = response.data
           self.comments.forEach((data) => {
            const city = self.cities.find((city) => city.id == data.dorm.city_id)
            // self.getCityDetails(city.id)
            data.dorm.city_name = city.name            
            // self.comments.push(data)
            })  
        })
        .catch(e => {
          this.errors.push(e)
        })
    }    
  },
  created() {
    this.getCities()
  }  

}
</script>

<style lang="scss">
  @import "../assets/scss/components/messages";
</style>
